module.exports = __webpack_public_path__ + "img/70_4.447730d5.png";